/**
 * Available Customer Identity field types.
 */
export enum CustomerIdentityField {
  /**
   * Only SSN is used as Customer Identity.
   */
  SSN,
  /**
   * Only Number is used as Customer Identity.
   */
  Number,
  /**
   * Both SSN and Number are used as Customer Identity.
   */
  SSNAndNumber
}
